<template>
    <v-btn
        outlined
        v-on="$listeners"
        :class="[
            buttonClass,
            buttonInfoDict.class
        ]"
        :color="buttonInfoDict.color">
        <icon
            v-if="!hideIcon"
            :value="buttonInfoDict.icon"/>

        {{ buttonInfoDict.text }}
    </v-btn>
</template>

<script>
export default {
    name: 'ButtonStatusField',

    props: {
        status: {
            type: String,
            default: ''
        },

        disableClick: {
            type: Boolean,
            default: false
        },

        hideIcon: {
            type: Boolean,
            default: false
        },

        status_color: {
            type: String,
            default: ''
        }
    },

    computed: {
        buttonClass () {
            return {
                unclickable: this.disableClick
            }
        },

        buttonInfoDict () {
            if (this.status === this.$constant.ACTIVE_STATUS) {
                if (this.status_color) {
                    return {
                        icon: 'done',
                        class: ` font-weight-regular ${this.status_color === this.$constant.ACTIVE_STATUS ? 'btn-field-active' : 'btn-field-inactive'} `,
                        text: this.$t('status.active'),
                        color: `${this.status_color === this.$constant.ACTIVE_STATUS ? 'activeStatus' : 'inactiveStatus'}`
                    }
                } else {
                    return {
                        icon: 'done',
                        class: 'font-weight-regular btn-field-active',
                        text: this.$t('status.active'),
                        color: 'activeStatus'
                    }
                }
            } else {
                if (this.status_color) {
                    return {
                        icon: 'close',
                        class: ` font-weight-regular ${this.status_color === this.$constant.INACTIVE_STATUS ? 'btn-field-inactive' : 'btn-field-inactive'} `,
                        text: this.$t('status.inactive'),
                        color: `${this.status_color === this.$constant.INACTIVE_STATUS ? 'error' : 'inactiveStatus'}`
                    }
                } else {
                    return {
                        icon: 'close',
                        class: 'font-weight-regular btn-field-inactive',
                        text: this.$t('status.inactive'),
                        color: 'inactiveStatus'
                    }
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-field-active {
    background: #F6FFED;
}
.btn-field-inactive {
    background: #f2f2f2;
}

</style>
